import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { scroller, Link as ScrollLink } from 'react-scroll'




const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();



  const handleNavigation = (section) => {

    if (location.pathname !== "/") {

      navigate("/");

      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 500,
          offset: -100,
        });
      }, 100);

    } else {

      scroller.scrollTo(section, {
        smooth: true,
        duration: 500,
        offset: -100,
      });

    }

    // closeMenu();
  };





  return (
    <>

      {/* TODO : FOOTER */}
      <footer className="ax-footer    mt-lg-5   ">
        <div className="ax-footer-layout">
          {/* ── LEFT CONTENT ── */}
          <div className="ax-footer-left">
            {/* Tagline */}
            <div className="ax-footer-tagline">
              <span className="ax-tag-upgradable">Upgradable</span><span className="ax-tag-dot1">.</span>
              <span className="ax-tag-affordable"> AFfordable</span><span className="ax-tag-dot2">.</span>
              <span className="ax-tag-flexible"> Flexible</span><span className="ax-tag-dot3">.</span>
            </div>
            {/* Nav Columns Grid */}
            <div className="ax-footer-nav-grid">
              {/* Home */}
              <div className="ax-footer-col">
                <div className="ax-footer-col-heading">Home</div>
                <ul className="ax-footer-col-links">
                  <li        className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "testimonial" },
                        })
                      }>
                    {/* <button
                      className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "testimonial" },
                        })
                      }
                    > */}
                      Testimonials
                    {/* </button> */}

                  </li>

                  <Link to="/blog"   className="ax-nav-link   custom-blog-footer-dec">Blog</Link>


                  <li    className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "pricing" },
                        })
                      }>
                      Offering
                  </li>
                </ul>
              </div>
              {/* Solutions */}
              <div className="ax-footer-col">
                <div className="ax-footer-col-heading">Solutions</div>
                <ul className="ax-footer-col-links">
                  {/* <li      className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "pricing" },
                        })
                      }>
                      One Price Infinite Potential
                  </li> */}
                  <li    className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "choose" },
                        })
                      }>
                      Why Choose Us                
                  </li>

                   <li   className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "about" },
                        })
                      }>
                      About Us
                  </li>

                  <Link to="/privacy-policy"   className="ax-nav-link   custom-blog-footer-dec">Privacy Policy</Link>
                </ul>
              </div>
              {/* Pricing */}
              <div className="ax-footer-col">
                <div className="ax-footer-col-heading">Features</div>
                <ul className="ax-footer-col-links">
                  {/* <li   className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "pricing" },
                        })
                      }>                   
                      One Price
                  </li> */}

                  <li     className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "feature" },
                        })
                      }>                    
                      Administrator Panel
                  </li>
                  <li    className="ax-nav-link"
                      onClick={() =>
                        navigate("/", {
                          state: { scrollTo: "feature" },
                        })
                      }>
                     Platform
                  </li>
                </ul>
              </div>
            </div>



          <div   className='pt-3'>
            <p className="ax-footer-desc">
              <span className="ax-desc-highlight-footer-sec">AxeSell is a modern eCommerce platform designed to help brands launch, manage, and scale their online business with ease. We combine powerful technology, custom website experiences, seamless integrations, automation tools, and dedicated support to help businesses grow faster, sell smarter, and create exceptional shopping experiences for their customers.</span>
            </p>
          </div>
          </div>

          <div className="ax-footer-divider" aria-hidden="true">
            <span className="ax-footer-divider-text"> All Rights Reserved Axesell @ {new Date().getFullYear()}</span>
          </div>
          {/* ── RIGHT PANEL ── */}
          <div className="ax-footer-right">
            {/* Logo */}
            <div className="ax-footer-logo-wrap">
              <div className="ax-footer-logo-icon">
                <img src="/assets/images/axeselllogo.webp" alt="axesell" />
              </div>
            </div>
            {/* Description */}
            <p className="ax-footer-desc">
              <span className="ax-desc-highlight">AxeSell is one of the best
                online e-commerce store and completely secure and fast for  solutions. It is the best choice for large or small types of e-commerce
                business.</span>
            </p>
            {/* Head Office */}
            <div className="ax-footer-info-block">
              <div className="ax-footer-info-heading">Head Office</div>
              <div className="ax-footer-info-text">
                KD-3,  New Delhi-110034  Pitampura. Axepert Exhibits Pvt. Ltd.
              </div>
            </div>
            {/* Contact */}
            <div className="ax-footer-info-block   pb-5">
              <div className="ax-footer-info-heading">Contact</div>
              <div className="ax-footer-info-text">
                 <a href="tel:011-43220041">011-43220041</a><br />
                <a href="mailto:mail@axesell.com">mail@axesell.com</a>
              </div>
            </div>
            {/* Social Icons */}
            <div className="ax-footer-socials">
              <a href="https://www.instagram.com/axesell.in/" target="_blank" className="ax-footer-social-link" aria-label="Instagram">
                <i className="bi bi-instagram" />
              </a>
              <a href="https://axesell.com/" target="_blank" className="ax-footer-social-link" aria-label="Website">
                <i className="bi bi-globe" />
              </a>
            </div>
          </div>
          {/* /right */}
        </div>
      </footer>

    </>
  )
}

export default Footer